import { render } from "./AreaGpReport.vue?vue&type=template&id=1cc5264e&ts=true&lang=pug"
import script from "./AreaGpReport.vue?vue&type=script&lang=ts"
export * from "./AreaGpReport.vue?vue&type=script&lang=ts"

import "./AreaGpReport.vue?vue&type=style&index=0&id=1cc5264e&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__